"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSignatureKeyIvr = void 0;
const types_1 = require("../../../features/authoriser/types");
class MbSignatureKeyIvr {
    constructor(api, data, manager) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
        this.manager = manager;
    }
    doTransfer() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.manager.getMethods().raiseN2InIvr(this.data.signatureKeyPositions, this.progressId);
        });
    }
    doVerify() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                type: types_1.ChallengeType.NONE,
                progressId: '',
            };
        });
    }
}
exports.MbSignatureKeyIvr = MbSignatureKeyIvr;
//# sourceMappingURL=signatureKeyIvr.js.map